import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';

import LoaderContext from '../../contexts/LoaderContext';
import Spinner, { SpinnerSize } from 'components/Spinner';
import { Backdrop } from './styles';
import Colors from 'constants/Colors';

const propTypes = {
  spinnerSize: PropTypes.oneOf([
    SpinnerSize.SMALL,
    SpinnerSize.MEDIUM,
    SpinnerSize.BIG
  ]),
  spinnerColor: PropTypes.string,
  backdropColor: PropTypes.string,
  opacity: PropTypes.number,
  fullScreen: PropTypes.bool
};

const defaultProps = {
  spinnerSize: SpinnerSize.SMALL,
  spinnerColor: null,
  backdropColor: Colors.PRIMARY,
  opacity: 0.5,
  fullScreen: false
};

export default function Loader({
  spinnerSize,
  spinnerColor,
  backdropColor,
  opacity,
  fullScreen
}) {
  const loaderContext = useContext(LoaderContext);

  if (!loaderContext.isLoading) return <></>;

  return (
    <Backdrop color={backdropColor} opacity={opacity} fullScreen={fullScreen}>
      <Spinner size={spinnerSize} color={spinnerColor} />
    </Backdrop>
  );
}

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;
